import { Alert, Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Select'
import i18n from 'modules/core/lib/i18n'

import { getResetFrequencyLabel } from 'modules/attendance/components/SettingItemPage/TimeTracking/PolicyBalance/FormComponent'
import {
  handleUpdateFrequencyI18n,
  updateFrequencyOptions,
} from 'modules/timeoff/components/TimeoffCompensation/utils/updateFrequencyOptions'
import type TimeoffCompensationForm from 'modules/timeoff/lib/TimeoffCompensationForm'

interface SelectFrequencyProps {
  form: TimeoffCompensationForm
  shouldUpdateBalanceReset: boolean
}

const SelectFrequency = ({ form, shouldUpdateBalanceReset }: SelectFrequencyProps) => {
  const frecuency = form.get('frequency').value

  return (
    <Box gap="s16">
      <Select
        value={frecuency}
        onChange={(selected) => form.setValues({ frequency: selected })}
        label={i18n.t(
          'time_tracking.settings.overtime.compensation.timeoff.form.content_labels.frequency'
        )}
        options={updateFrequencyOptions()}
        showOriginalLabelText
      />
      {shouldUpdateBalanceReset && (
        <Alert color="warning">
          <Text.Normal weight="medium" size="300">
            {i18n.t(
              'time_tracking.settings.overtime.compensation.timeoff.form.update_balance_reset_warning',
              {
                balance_reset_frequency: getResetFrequencyLabel(frecuency),
                ovetime_timeoff_compensation_frequency: handleUpdateFrequencyI18n(frecuency),
              }
            )}
          </Text.Normal>
        </Alert>
      )}
    </Box>
  )
}

export default observer(SelectFrequency)
